/* eslint-disable */
// Check if .video-player exists on the page
const videoPlayer = document.querySelector('.video-player');

if (videoPlayer) {
    // Get the video element
    const video = document.getElementById('video-player-video');

    // Function to handle video playback
    function handleVideoPlayback(entries, observer) {
        entries.forEach(entry => {
            // Check if the video is intersecting with the viewport
            if (entry.isIntersecting) {
                // Play the video
                video.play();
            } else {
                // Pause the video
                video.pause();
            }
        });
    }

    // Options for the Intersection Observer
    const options = {
        threshold: 0.5 // Trigger when at least 50% of the video is visible
    };

    // Create a new Intersection Observer
    const observer = new IntersectionObserver(handleVideoPlayback, options);

    // Start observing the video element
    observer.observe(video);
}
/* eslint-enable */
